import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { useContext, useEffect } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import DateTimePickerWithTimeZone from "../../common/DateTime/DateTimePickerWithTimeZone";

const DateTimePickerComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    required,
    uischema,
    schema,
    enabled,
  } = props;
  const {
    globalState: { programConfig },
  } = useContext(GlobalConfigContext);
  const currentProgramTimezone = programConfig?.localization?.programTimezone;
  const ctx = useJsonForms();
  const showValidation = ctx?.config?.showValidation;
  const formData = ctx?.core?.data;

  const gtField = uischema?.rule?.condition?.schema?.gt;
  const gtValue = gtField ? formData?.[gtField] : undefined;

  useEffect(() => {
    if (gtValue && data && new Date(gtValue) >= new Date(data)) {
      handleChange(path, null);
    }
  }, [gtValue, data, handleChange, path]);

  return (
    <>
      {currentProgramTimezone ? (
        <DateTimePickerWithTimeZone
          dateTime={data}
          setDateTime={(newVal) => handleChange(path, newVal)}
          timezone={currentProgramTimezone}
          format={schema?.date_format}
          label={`${label}${required ? "*" : ""}`}
          errors={errors}
          required={required}
          minimum={uischema?.minimum}
          disabled={!enabled || uischema?.disabled}
          uischema={uischema}
          otherData={formData}
          showValidation={showValidation}
          slotProps={{
            actionBar: {
              actions: ["clear", "accept"],
            },
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export const DateTimePickerControl = withJsonFormsControlProps(
  DateTimePickerComponent
);
